import JSONAPIAdapter from '@ember-data/adapter/json-api';

import { apiBaseURL, receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';

export default class ReceivableInvoiceAdapter extends JSONAPIAdapter {
  host = apiBaseURL;
  namespace = receivableInvoicesApiNamespace;
  useFetch = true;

  pathForType() {
    return 'receivable_invoices/invoices/shared';
  }
}
